module.exports = __webpack_public_path__ + "img/flag-500.b0d37ffc.png";